import {fetchMe, sendDefaultLocation, sendPreferenceData, sendProfileData} from '../../store/slices/me_slice';
import {parseIntOrFallback} from '../../support/parse_int';
import {store as AppStore} from '../../store/store';
import {isRejected} from '@reduxjs/toolkit';
import {redirect} from 'react-router-dom';
import {CustomerPreferencesInputType} from '../../gql/customer/graphql.ts';
import {CustomerPreferences} from '../../support/get_data.ts';

export async function storeProfileData(store: typeof AppStore, token: string, formData: FormData) {
    const defaultLocation = formData.get('default_location');
    const locationId = parseIntOrFallback(defaultLocation, null);
    const isFromOnboarding = formData.get('is_from_onboarding') === 'true';

    let customerId = store.getState().customerInfo?.me?.customer?.id;
    if (customerId === null || customerId === undefined) {
        const meResult = await store.dispatch(fetchMe({token}));
        if (isRejected(meResult)) {
            throw meResult.error;
        }
        customerId = meResult.payload.me?.customer?.id;
    }
    if (customerId === null || customerId === undefined) {
        throw redirect('/login');
    }
    if (locationId !== null) {
        const locationResult = await store.dispatch(sendDefaultLocation({token, locationId: locationId}));
        if (isRejected(locationResult)) {
            throw locationResult.error;
        }
    }
    formData.delete('default_location');

    const preferences = Array.from(formData.entries()).filter(([key]) => key.includes('receive'));
    if (!isFromOnboarding) {
        let preferencesArray: {[index: string]: boolean} = {};
        Object.values(CustomerPreferences).forEach((preference: string) => {
            if (!preference.includes('reminder') && !preference.includes('receive_push_notification_channel')) {
                preferencesArray = {
                    ...preferencesArray,
                    ...{[preference]: preferences.some((item) => item.some((value) => value === preference))},
                };
            }
        });

        const preferenceData: CustomerPreferencesInputType = {
            customer_id: customerId,
            ...preferencesArray,
        };
        const preferenceResult = await store.dispatch(sendPreferenceData({token, preferenceData}));

        if (isRejected(preferenceResult)) {
            throw preferenceResult.error;
        }
    }

    const profileEntries = Array.from(formData.entries()).filter(
        ([key]) => !key.includes('receive') && !key.includes('-disabled') && !key.includes('is_from_onboarding'),
    );
    const data = profileEntries.map(([key, value]) => {
        return {
            key,
            value: value.toString(),
        };
    });

    const profileResult = await store.dispatch(sendProfileData({token, data}));
    if (isRejected(profileResult)) {
        throw profileResult.error;
    }
}
